import './assets/main.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { datadogRum } from '@datadog/browser-rum'
import { PrevioDesignSystem } from '@previo/design-system'
import VueGtagPlugin from 'vue-gtag'
import { i18n, useLocale } from '@previo/core'
import App from './App.vue'
import router from './router'
import messages from '~/locales'
import { Environment } from '~/Environment'

const pinia = createPinia()
const app = createApp(App)

useLocale().setMessages(messages)

app.use(pinia)
pinia.use(piniaPluginPersistedstate)
app.use(i18n)
app.use(router)
app.use(PrevioDesignSystem)
app.use(
  VueGtagPlugin,
  {
    config: {
      id: import.meta.env.ID_FE_GOOGLE_ANALYTICS_4_KEY,
    },
  },
  router,
)

app.mount('#app')

if (Environment.isEnvLikeProduction()) {
  datadogRum.init({
    applicationId: import.meta.env.ID_FE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.ID_FE_DATADOG_CLIENT_TOKEN,
    version: import.meta.env.ID_FE_APP_VERSION,
    site: 'datadoghq.eu',
    service: 'previo2-id-fe',
    env: Environment.SELECTED,
    sessionSampleRate: 10,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  })
}
